<template>
	<div class="page-login" v-if="!isLoggedIn">
		<div class="container">
			<!-- Login Logo -->
			<div class="login-logo text-center">
				<picture>
					<img src="/img/logo/grafias_medium_ondark.png" class="d-inline-block m-auto" loading="lazy" alt="Grafias">
				</picture>
			</div>
			<!-- Login Box -->
			<div class="login-box card magic-link-box"  v-if="!isCreated && !showErrorInformation">
				<div class="login-box-content">
					<div class="login-error callout callout--danger hidden" v-if="loginError">
						<div class="callout__content">{{ loginError }}</div>
					</div>
					<form @submit.prevent="resetPassword">
						<div class="mb-3">
							<h2 class="font-weight-normal">{{ $t('Set Your Password') }}</h2>
						</div>
						<div class="text-small mb-3">
							{{ $t('You opted to reset your password on magic link request. Please set your account password to proceed') }}
						</div>
						<!-- New Password -->
						<div class="form-group">
							<div class="d-flex justify-content-between">
								<label>{{ $t('Password') }}</label>
								<span class="font-small mt-1"
									:class="{'very-weak': warningError === 'Weak',
										'weak': warningError === 'Medium',
										'strong': warningError === 'Strong',
									}">
									{{warningError}}
								</span>
							</div>
							<input-password v-model="password" :required="false"/>
							<span class="text-danger text-small" v-if="warningError === 'Weak' && password">{{$t('Please enter a password of at least 8 characters, and use a combination of letters and numbers')}}</span>
						</div>
						<!-- Confirm New Password -->
						<div class="form-group mb-5">
							<div class="d-flex justify-content-between">
								<label>{{ $t('Confirm New Password') }}</label>
								<label class="text-danger text-small" v-if="confirmPassword && confirmPassword !== password">{{$t('Password do not match')}}</label>
							</div>
							<!-- <input type="password" name="confirm-new-password" class="form-control" v-model="confirmPassword" required> -->
							<input-password v-model="confirmPassword" />
						</div>
						<!-- Submit -->
						<button
							type="submit"
							class="btn btn-submit btn-primary"
							:disabled="!isFormValid"
							:class="{ 'is-loading': isResetting }">
							{{ $t('SET MY PASSWORD') }}
						</button>
					</form>
				</div>
			</div>
			<div class="message-box text-center" v-if="showErrorInformation">
				<img src="/img/OOPS.png" class="d-inline-block m-auto" loading="lazy" alt="Grafias">
				<span>
				<h3 class="mb-5 mt-4 text-center">{{ messageError }},
				<router-link
					to="/login"
					class="primary-text pb-1">
					{{ $t('click here to access Grafi.as') }}
				</router-link></h3>
			</span>
			</div>
			<div class="message-box text-center" v-if="isCreated">
				<h3 class="mb-5">{{ $t('Your password has been changed!') }}</h3>
				<router-link
					to="/login"
					class="btn btn-submit btn-primary mt-3">
					{{ $t('Back To Login') }}
				</router-link>
			</div>
		</div>
		<div class="modals">
			<!-- Login Error -->
			<modal class="login-error-modal" size="small" v-if="error" @close="error = false">
				<div slot="header">{{$t('Login Error')}}</div>
				<div slot="body" class="text-left">
					<div v-if="errorMessage === ''">{{ $t('Wrong Email or Password') }}</div>
					<div v-else>{{ errorMessage }}</div>
				</div>
				<div slot="footer">
					<button type="button" class="btn btn-secondary" @click="error = false">OK</button>
				</div>
			</modal>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { getAxiosErrorMessage } from '../lib/helper';
import InputPassword from '@/components/InputPassword.vue';
import Modal from '../components/Modal.vue';
import authApi from '../api/auth';

export default {
	name: 'ChangePassword',
	components: {
		Modal,
		InputPassword,
	},
	data() {
		return {
			password: '',
			confirmPassword: '',
			error: false,
			languageLabel: {
				en: 'English',
				no: 'Norsk',
			},
			isResetting: false,
			isCreated: false,
			errorMessage: '',
			messageError: '',
			showErrorInformation: '',
			warningError: '',
			score: '',
		};
	},
	methods: {
		...mapActions({
			setLocale: 'setLocale',
		}),
		resetPassword() {
			this.isResetting = true;
			const params = {
				new_password: this.password,
				confirm_password: this.confirmPassword,
				confirm_Password: this.confirmPassword,
				lang: 'en',
			};
			const callback = (response) => {
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Reset Password',
					text: message,
				});
				this.isResetting = false;
				this.isCreated = true;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				// this.$notify({
				// 	group: 'app',
				// 	type: 'error',
				// 	title: 'Reset Password',
				// 	text: message,
				// });
				this.showErrorInformation = true;
				this.messageError = message;
				this.isResetting = false;
			};
			authApi.resetPassword(this.email, this.token, params, callback, errorCallback);
		},
		checkLogin() {
			if (this.isLoggedIn) {
				this.$router.push('/logout').catch(() => {});
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			locale: 'locale',
			isLoggedIn: 'isLoggedIn',
			loginError: 'loginError',
		}),
		email() {
			const { email } = this.$route.query;
			return email;
		},
		token() {
			const { token } = this.$route.query;
			return token;
		},
		lang() {
			const lang = this.$route.query.lang || this.locale;
			return lang;
		},
		isFormValid() {
			return (
				this.password === this.confirmPassword
				&& this.warningError !== 'Weak'
			);
		},
	},
	watch: {
		loginError(loginError) {
			if (loginError) {
				this.error = true;
				this.errorMessage = loginError;
			}
		},
		password() {
			if (this.password !== '') {
				/* eslint-disable global-require */
				const passwordStrength = require('check-password-strength');
				if (this.password.length < 8) {
					this.warningError = 'Weak';
				} else {
					/* eslint-enable global-require */
					this.warningError = passwordStrength(this.password).value;
				}
			}
			if (this.password === '') this.warningError = '';
		},
	},
	created() {
		this.checkLogin();
	},
};
</script>
